/** Soft empty-thread lines. Add more here — components only call pickEmptyCommentMessage(). */
export const EMPTY_COMMENT_MESSAGES = [
  "It's quiet here... for now.",
  "No one's spoken up yet. No pressure if you'd rather just watch.",
  "Nothing said yet — whenever you're ready.",
  "A little quiet down here. Feel free to change that.",
  "First one here? That's kind of nice.",
  "No comments yet — but there's room for one.",
  "It's just you and the drop right now.",
  "You're early. There's something nice about that.",
  "Nobody's here yet. Just you, for now.",
  "Just you here right now. That's its own kind of moment.",
  "You beat everyone here. A little bit lucky, honestly.",
];

export function pickEmptyCommentMessage() {
  const list = EMPTY_COMMENT_MESSAGES;
  return list[Math.floor(Math.random() * list.length)];
}
